import { Chip } from "@stenajs-webui/elements";
import { useContext } from "react";

export const FilterChip = function SearchFilterChip<
  TFormModel,
  TSectionKey extends string
>({ label, onClickHandler }: { label: string; onClickHandler: () => void }) {
  return <Chip label={label} onClick={onClickHandler} />;
};
